import { AfterViewInit, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import confetti from 'canvas-confetti';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

let purchasedBefore = false

@Component({
  selector: 'app-celebration',
  standalone: true,
  imports: [ConfirmDialogModule],
  templateUrl: './celebration.component.html',
  styleUrl: './celebration.component.scss',
  providers: [ConfirmationService]
})
export class CelebrationComponent implements AfterViewInit {
  private confirmationService = inject(ConfirmationService)
  private router = inject(Router)

  ngAfterViewInit(): void {
    if (purchasedBefore) return
    purchasedBefore = true
    var end = Date.now() + (15 * 1000);
    var colors = ['#fbbf24', '#ffffff'];

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
    this.confirmationService.confirm({
      header: 'Purchase Success',
      message: "You're all set to start rendering. Jump in and start customizing your maps! If you need help, check out our discord or reach out for support. Happy rendering!",
      icon: 'fi fi-rr-party-horn',
      rejectVisible: false,
      acceptIcon: "pf",
      acceptLabel: 'Close',
      accept: () => this.router.navigate(['my-renders'])
    })
  }
}
